import { useEffect, useState } from 'react';

// Fallback used until (or if) the runtime config can't be loaded.
const fallbackResumeUrl = `${process.env.PUBLIC_URL}/Anurag-Kumar-Resume.pdf`;
let cached: string | null = null;

// Reads public/site-config.json at runtime, so the resume link can change
// without rebuilding the app. Edit that file (or the PDF it points to) in place.
export function useResumeUrl() {
  const [url, setUrl] = useState(cached ?? fallbackResumeUrl);
  useEffect(() => {
    if (cached) return;
    fetch(`${process.env.PUBLIC_URL}/site-config.json`, { cache: 'no-cache' })
      .then(res => (res.ok ? res.json() : null))
      .then(config => {
        if (config && typeof config.resumeUrl === 'string' && config.resumeUrl) {
          cached = config.resumeUrl;
          setUrl(config.resumeUrl);
        }
      })
      .catch(() => { /* keep fallback */ });
  }, []);
  return url;
}
